<template>
  <expandable header="Serology" class="mb-10">
    <b-row>
      <b-col cols="12" md="4">
        <yes-no
          v-model="form.syphilis_serology"
          label="Syphilis Serology"
          :disabled="isDisabled"
          @input="onInput"
        ></yes-no>
      </b-col>
      <b-col cols="12" md="4">
        <yes-no
          v-model="form.anti_hbc_total"
          label="Anti HBc (Total)"
          :disabled="isDisabled"
          @input="onInput"
        ></yes-no>
      </b-col>
    </b-row>
  </expandable>
</template>

<script>
import Expandable from "../../Expandable.vue";
import YesNo from "../../form/YesNo.vue";

export default {
  components: { Expandable, YesNo },
  props: {
    value: {},
    isDisabled: { default: false, type: Boolean },
  },
  data() {
    return { form: {} };
  },
  methods: {
    onInput() {
      this.$emit("input", this.form);
    },
  },
  beforeMount() {
    this.form = this.value;
  },
  mounted() {
    this.onInput();
  },
};
</script>
